import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

@observer
class NotFoundModal extends Component {
 
  render() {
    const orderRoute = this.props.selectedStreet.map( (street, i) => {
      return (<p key={`${street}-${this.props.selectedHouse[i]}`}>{street} {this.props.selectedHouse[i]}</p>)
    })
 
    return (
      <div className="car_ordering_items">
        <div className="top_row">
          <button className="order_items"><i className="btn-toggle__icon--order close"></i></button>
          <div className="search_car">
            <span>АВТО НЕ НАЙДЕНО</span>
          </div>
        </div>
        <div className="rows">
          <div className="middle_row">
            <i className="icon"></i>
            <div className="streets">
              {orderRoute}
            </div>
          </div>
          <div className="bottom_row">
            <button className="btn-cancel" id="order-module-cancel-btn-stage-1" onClick={this.props.cancelOrder}>
              <i className="btn-cancel__icon"></i>
              <span>Отменить заказ</span>
            </button>
          </div>
          <div className="right_column">
            <div className="restart-auto-search" onClick={this.props.restartAutoSearch}>
              <span>Попробовать еще раз</span>
              <i className="circle_arrow"></i>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const withData = inject(stores => ({
  selectedStreet: stores.OrderStore.selectedStreet,
  selectedHouse: stores.OrderStore.selectedHouse,
  cancelOrder: stores.OrderStore.cancelOrder,
  restartAutoSearch: stores.OrderStore.restartAutoSearch,
}))

export default withData(NotFoundModal);
